import React from 'react';
import {
  Box,
  chakra,
  Container,
  Link,
  Divider,
  Stack,
  Flex,
  Text,
  useColorModeValue,
  VisuallyHidden,
} from '@chakra-ui/react';
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Link as ReachLink } from 'react-router-dom';
const Logo = props => {
  return (
    <svg
      width="119"
      height="33"
      viewBox="0 0 119 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.3806 11.2339C37.4884 11.2339 38.4565 11.4485 39.2849 11.8777C40.1233 12.2969 40.767 12.9057 41.2162 13.7041C41.6753 14.4926 41.9048 15.4158 41.9048 16.4737C41.9048 17.5317 41.6753 18.4499 41.2162 19.2284C40.767 20.0069 40.1233 20.6057 39.2849 21.0249C38.4565 21.4341 37.4884 21.6387 36.3806 21.6387H32.9822V11.2339H36.3806ZM36.3806 20.2464C37.5982 20.2464 38.5314 19.917 39.1801 19.2583C39.8289 18.5996 40.1532 17.6714 40.1532 16.4737C40.1532 15.2661 39.8289 14.3229 39.1801 13.6442C38.5314 12.9656 37.5982 12.6262 36.3806 12.6262H34.6889V20.2464H36.3806ZM51.7404 19.5128H47.3839L46.6354 21.6387H44.8538L48.5816 11.219H50.5577L54.2855 21.6387H52.489L51.7404 19.5128ZM51.2614 18.1205L49.5696 13.2849L47.863 18.1205H51.2614ZM64.4996 11.2339V12.6262H61.7299V21.6387H60.0233V12.6262H57.2387V11.2339H64.4996ZM74.3721 19.5128H70.0156L69.2671 21.6387H67.4855L71.2133 11.219H73.1894L76.9172 21.6387H75.1207L74.3721 19.5128ZM73.893 18.1205L72.2013 13.2849L70.4947 18.1205H73.893ZM89.3769 11.2339L85.4695 21.6387H83.4933L79.571 11.2339H81.3974L84.4814 19.8871L87.5804 11.2339H89.3769ZM94.3822 11.2339V21.6387H92.6755V11.2339H94.3822ZM101.893 11.2339C103 11.2339 103.969 11.4485 104.797 11.8777C105.635 12.2969 106.279 12.9057 106.728 13.7041C107.187 14.4926 107.417 15.4158 107.417 16.4737C107.417 17.5317 107.187 18.4499 106.728 19.2284C106.279 20.0069 105.635 20.6057 104.797 21.0249C103.969 21.4341 103 21.6387 101.893 21.6387H98.4942V11.2339H101.893ZM101.893 20.2464C103.11 20.2464 104.043 19.917 104.692 19.2583C105.341 18.5996 105.665 17.6714 105.665 16.4737C105.665 15.2661 105.341 14.3229 104.692 13.6442C104.043 12.9656 103.11 12.6262 101.893 12.6262H100.201V20.2464H101.893ZM114.408 21.7435C113.709 21.7435 113.081 21.6237 112.522 21.3842C111.963 21.1347 111.524 20.7853 111.204 20.3362C110.885 19.8871 110.725 19.3631 110.725 18.7643H112.552C112.592 19.2134 112.766 19.5827 113.076 19.8721C113.395 20.1615 113.839 20.3063 114.408 20.3063C114.997 20.3063 115.456 20.1665 115.785 19.8871C116.115 19.5976 116.279 19.2284 116.279 18.7792C116.279 18.4299 116.175 18.1455 115.965 17.9259C115.765 17.7063 115.511 17.5367 115.201 17.4169C114.902 17.2971 114.483 17.1674 113.944 17.0277C113.265 16.848 112.711 16.6684 112.282 16.4887C111.863 16.2991 111.504 16.0096 111.204 15.6204C110.905 15.2312 110.755 14.7122 110.755 14.0634C110.755 13.4646 110.905 12.9406 111.204 12.4915C111.504 12.0424 111.923 11.698 112.462 11.4585C113.001 11.219 113.625 11.0992 114.333 11.0992C115.341 11.0992 116.165 11.3537 116.803 11.8627C117.452 12.3617 117.811 13.0504 117.881 13.9287H115.995C115.965 13.5494 115.785 13.2251 115.456 12.9556C115.127 12.6861 114.692 12.5514 114.153 12.5514C113.664 12.5514 113.265 12.6761 112.956 12.9256C112.646 13.1752 112.492 13.5345 112.492 14.0035C112.492 14.3229 112.587 14.5874 112.776 14.797C112.976 14.9966 113.225 15.1563 113.525 15.2761C113.824 15.3958 114.233 15.5256 114.752 15.6653C115.441 15.8549 116 16.0446 116.429 16.2342C116.868 16.4238 117.237 16.7183 117.537 17.1175C117.846 17.5067 118.001 18.0307 118.001 18.6894C118.001 19.2184 117.856 19.7174 117.567 20.1865C117.287 20.6556 116.873 21.0348 116.324 21.3243C115.785 21.6037 115.147 21.7435 114.408 21.7435Z"
        fill="black"
      />
      <path
        d="M15.1339 16.902V2.53583C15.1339 1.05848 13.2867 0.389689 12.3409 1.52462L0.369125 15.8908C-0.488213 16.9196 0.243369 18.4816 1.58257 18.4816H13.5544C14.4267 18.4816 15.1339 17.7744 15.1339 16.902Z"
        fill="url(#paint0_linear_1475_12146)"
      />
      <path
        d="M9.49269 16.6763L9.49269 31.0424C9.49269 32.5198 11.3399 33.1886 12.2857 32.0536L24.2575 17.6875C25.1148 16.6587 24.3833 15.0967 23.0441 15.0967H11.0722C10.1999 15.0967 9.49269 15.8039 9.49269 16.6763Z"
        fill="url(#paint1_linear_1475_12146)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1475_12146"
          x1="0"
          y1="32.6251"
          x2="24.6266"
          y2="32.6251"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EE0979" />
          <stop offset="1" stopColor="#FF6A00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1475_12146"
          x1="0"
          y1="32.6251"
          x2="24.6266"
          y2="32.6251"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EE0979" />
          <stop offset="1" stopColor="#FF6A00" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      rounded={'full'}
      w={8}
      h={8}
      cursor={'pointer'}
      as={'a'}
      href={href}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={{
        bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function Footer() {
  return (
    <Box
      bg={useColorModeValue('gray.50', 'gray.900')}
      color={useColorModeValue('gray.700', 'gray.200')}
    >
      <Container
        as={Stack}
        maxW={'6xl'}
        py={4}
        direction={{ base: 'column', md: 'row' }}
        spacing={4}
        justify={{ base: 'center', md: 'space-between' }}
        align={{ base: 'center', md: 'center' }}
      >
        <Flex gap={5}>
          <Link as={ReachLink} to="/">
            Home
          </Link>
          <Link as={ReachLink} to="/terms">
            Terms Of Use
          </Link>
          <Link as={ReachLink} to="/privacy">
            Privacy Policy
          </Link>
        </Flex>
        <Stack direction={'row'} spacing={6}>
          <SocialButton label={'Twitter'} href={'#'}>
            <FaTwitter />
          </SocialButton>
          <SocialButton label={'YouTube'} href={'#'}>
            <FaYoutube />
          </SocialButton>
          <SocialButton label={'Instagram'} href={'#'}>
            <FaInstagram />
          </SocialButton>
        </Stack>
      </Container>
      <Divider orientation="horizontal" />
      <Container
        as={Stack}
        maxW={'6xl'}
        py={4}
        direction={{ base: 'column', md: 'row' }}
        spacing={4}
        justify={{ base: 'center', md: 'space-between' }}
        align={{ base: 'center', md: 'center' }}
      >
        <Logo />
        <Text fontSize={{ base: 'sm' }}>
          © 2022 DataVids. All rights reserved
        </Text>
      </Container>
    </Box>
  );
}
